<template>
  <div class="el-popper capital-dropdown" :class="{'hq-capital-dropdown':HQ}" :style="{ width: '340px' }">
    <div id="confirmButton">
      <el-row style="padding-left: 13px; margin:0; padding: 10px; border-bottom: 1px solid #d8dce5" :gutter="10">
        <el-col :span='7'>
          <el-input :class="{'capital-error': (startError || compareError)}" v-model="start" placeholder="最小" @focus="clearInputError" :maxlength=6></el-input>
        </el-col>
        <el-col style="margin-top:4px;margin-left: -3px;" :span="1">-</el-col>
        <el-col :span='7'>
          <el-input :class="{'capital-error': (endError || compareError)}" v-model="end" placeholder="最大" @focus="clearInputError" :maxlength=6></el-input>
        </el-col>
        <el-col style="font-size: 14px; padding-left: 0;margin-top: 10px;" :span="1">年</el-col>
        <el-col :span="4" style="margin-left: 16px">
          <el-button type="primary" @click="addCustom" id='establishSelect' :name="$route.name+'-establishSelect'">确定</el-button>
        </el-col>
      </el-row>
      <div @click="onSelect('0')" :class="[check(0) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='0'}]">全部</div>
      <div @click="onSelect('1')" :class="[check(1) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='1'}]">一年以内</div>
      <div @click="onSelect('2')" :class="[check(2) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='2'}]">1-5年</div>
      <div @click="onSelect('3')" :class="[check(3) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='3'}]">5-10年</div>
      <div @click="onSelect('4')" :class="[check(4) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='4'}]">10-15年</div>
      <div @click="onSelect('5')" :class="[check(5) ? 'capital-item selected' : 'capital-item',{'not-allowed':initialCapital&&initialCapital!='5'}]">15年以上</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['value','querystring'],
    inject: ['select'],
    data() {
      return {
        minWidth: '',
        start: '',
        end: '',
        startDirty: false,
        endDirty: false,
        startError:false,
        endError:false,
        compareError:false,
        HQ: __VERSION === 'HQ'

      };
    },

    computed: {
      popperClass() {
        return this.$parent.popperClass;
      },
      initialCapital () {
      if (!this.querystring) return null;
      if (this.querystring.indexOf('}') != -1) {
        let form = JSON.parse(this.querystring);
        if (form.filter) {
          form.filter = JSON.parse(form.filter);
        }
        if (form.filter.establishment != '0') {
          return form.filter.establishment;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
    },

    watch: {
      '$parent.inputWidth'() {
        this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
      },
      'select.visible'() {
        if (!this.select.visible) {
          this.startDirty = false;
          this.endDirty = false;
          this.start = '';
          this.end = '';
        } else {
          if (this.value.indexOf(',') != -1) {
            const arr = this.value.split(',');
            this.start = arr[0];
            this.end = arr[1];
          }
        }
        this.clearInputError();
      },
    },

    methods: {
      checkInput(){
        let numberRE = /(^[1-9]\d{0,5}$)|(^0$)/;
        this.startError =(!numberRE.test(this.start) && this.start.trim() != '')?true:false;
        this.endError =(!numberRE.test(this.end) && this.end.trim() != '')?true:false;
        if (this.start.trim() || this.end.trim()) {
          this.compareError = parseInt(this.end) <= parseInt(this.start) ? true : false;
        } else {
          this.compareError = true;
        }
      },
      clearInputError(){
        this.startError = this.endError = this.compareError = false;
      },
      addCustom() {
        this.checkInput();
        if(!(this.startError || this.endError || this.compareError)){
          const data =
            (this.start ? this.start : '') + ',' + (this.end ? this.end : '');
          this.$emit('input', data);
          this.select.visible = false;
        }
      },
      onSelect(val) {
        if(this.initialCapital&&this.initialCapital!=val){
        return
        }
        this.$emit('input', val);
        this.start = '';
        this.end = '';
        this.select.visible = false;
      },
      check(val) {
        if (this.value == val) {
          return true;
        }
      }
    },

    mounted() {

      if (this.value.indexOf(',') != -1) {
        const arr = this.value.split(',');
        this.start = arr[0];
        this.end = arr[1];
      }
    }
  };
</script>
<style lang="scss" scoped>
  .capital-dropdown {
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .capital-item {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5a5e66;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
      &.not-allowed{
    cursor: not-allowed;
    color: #999;
  }
  }

  .capital-item.selected {
    color: #46c8c8;
  }
  .hq-capital-dropdown {
  .capital-item {
    &.selected {
      color: #337ab7;
    }
  }
}
  // .capital-item.selected:after {
  //   position: absolute;
  //   right: 20px;
  //   font-family: element-icons;
  //   content: '\E611';
  //   font-size: 12px;
  //   font-weight: 700;
  //   -webkit-font-smoothing: antialiased;
  // }

  .capital-item.hover,
  .capital-item:hover {
    background: #f5f7fa;
  }
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/establish.vue